import React, { useState } from "react";
import { Box, Paper, Typography, Chip, Stack } from "@mui/material";
import PlaceRoundedIcon from "@mui/icons-material/PlaceRounded";
import NotificationsActiveRoundedIcon from "@mui/icons-material/NotificationsActiveRounded";
import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";
import { useNavigate } from "react-router-dom";
import Content from "../../../components/Content";
import { useGeofence } from "../../../hooks/useGeofence";

const getOrgId = () => {
  try {
    const userData = localStorage.getItem("userData");
    if (!userData) return null;
    return JSON.parse(userData)?.organisation_id ?? null;
  } catch {
    return null;
  }
};

const SettingCard = ({ icon, title, description, status, onClick }) => (
  <Paper
    onClick={onClick}
    sx={{
      p: 3,
      borderRadius: 3,
      cursor: "pointer",
      boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
      transition: "all 0.2s ease",
      display: "flex",
      alignItems: "center",
      gap: 2,
      "&:hover": {
        transform: "translateY(-2px)",
        boxShadow: "0 8px 24px rgba(16,50,74,0.12)",
      },
    }}
  >
    <Box
      sx={{
        width: 48,
        height: 48,
        borderRadius: 2,
        background: "rgba(138,17,37,0.08)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "#8a1125",
        flexShrink: 0,
      }}
    >
      {icon}
    </Box>
    <Box sx={{ flex: 1, minWidth: 0 }}>
      <Stack direction="row" alignItems="center" spacing={1}>
        <Typography variant="subtitle1" sx={{ fontWeight: 600, color: "#1a1d23" }}>
          {title}
        </Typography>
        {status}
      </Stack>
      <Typography variant="body2" sx={{ color: "#5f6877" }}>
        {description}
      </Typography>
    </Box>
    <ChevronRightRoundedIcon sx={{ color: "#9aa1ab" }} />
  </Paper>
);

export const SettingsOverviewView = () => {
  const navigate = useNavigate();
  const [organisationId] = useState(getOrgId);
  const { data: geofence, isLoading } = useGeofence(organisationId);

  const configured = Boolean(geofence?.polygon?.coordinates?.[0]?.length >= 4);

  return (
    <Content title="Inställningar" subtitle="Anpassa hur Varna fungerar för er organisation">
      <Box sx={{ p: 3, display: "grid", gap: 2, gridTemplateColumns: { xs: "1fr", md: "repeat(2, 1fr)" } }}>
        <SettingCard
          icon={<PlaceRoundedIcon />}
          title="Platsområde"
          description="Definiera vilket område som räknas till er adress för alarmbevakning."
          status={
            isLoading ? (
              <Chip size="small" label="Laddar…" />
            ) : configured ? (
              <Chip size="small" color="success" label="Konfigurerad" />
            ) : (
              <Chip size="small" label="Ej konfigurerad" />
            )
          }
          onClick={() => navigate("/admin/settings/geofence")}
        />
        <SettingCard
          icon={<NotificationsActiveRoundedIcon />}
          title="Larmknappar"
          description="Konfigurera vilka larmknappar som visas för er organisations användare."
          onClick={() => navigate("/admin/settings/alarm-buttons")}
        />
      </Box>
    </Content>
  );
};
